import type { IconNode } from '../types';

/**
 * @name fox-face-tail
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTkuOSA4LjNDMjAuNiA3IDIxIDUuNiAyMSA0YzAtLjYtLjQtMS0xLTEtMi4zIDAtNC4zLjgtNS45IDIuMmExNC45MiAxNC45MiAwIDAgMC00LjIgMEE4Ljc4IDguNzggMCAwIDAgNCAzYy0uNiAwLTEgLjQtMSAxIDAgMS42LjQgMyAxLjEgNC4zLS42LjctMS4xIDEuNC0xLjQgMi4yQzQgMTMgMTEgMTYgMTIgMTZzOC0zIDkuMy01LjVjLS4zLS44LS44LTEuNS0xLjQtMi4yIiAvPgogIDxwYXRoIGQ9Ik05IDl2LjUiIC8+CiAgPHBhdGggZD0iTTEzIDEzaC0yIiAvPgogIDxwYXRoIGQ9Ik0xMiAxNnYtMyIgLz4KICA8cGF0aCBkPSJNMTUgOXYuNSIgLz4KICA8cGF0aCBkPSJNNi4zIDIwLjVBNi44NyA2Ljg3IDAgMCAwIDkgMTVIMi4yYy44IDQgNC45IDcgOS44IDcgNS41IDAgMTAtMy44IDEwLTguNSAwLTEuMS0uMi0yLjEtLjctMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/fox-face-tail
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const foxFaceTail: IconNode = [
  [
    'path',
    {
      d: 'M19.9 8.3C20.6 7 21 5.6 21 4c0-.6-.4-1-1-1-2.3 0-4.3.8-5.9 2.2a14.92 14.92 0 0 0-4.2 0A8.78 8.78 0 0 0 4 3c-.6 0-1 .4-1 1 0 1.6.4 3 1.1 4.3-.6.7-1.1 1.4-1.4 2.2C4 13 11 16 12 16s8-3 9.3-5.5c-.3-.8-.8-1.5-1.4-2.2',
      key: 'wzeb8n',
    },
  ],
  ['path', { d: 'M9 9v.5', key: '1wy2py' }],
  ['path', { d: 'M13 13h-2', key: '1ewkhd' }],
  ['path', { d: 'M12 16v-3', key: 'fytpmj' }],
  ['path', { d: 'M15 9v.5', key: 'sjxt5z' }],
  [
    'path',
    {
      d: 'M6.3 20.5A6.87 6.87 0 0 0 9 15H2.2c.8 4 4.9 7 9.8 7 5.5 0 10-3.8 10-8.5 0-1.1-.2-2.1-.7-3',
      key: '6dzma',
    },
  ],
];

export default foxFaceTail;
